//             ,d
//             88
// ,adPPYba, MM88MMM ,adPPYba,  8b,dPPYba,
// I8[    ""   88   a8"     "8a 88P'    "8a
// `"Y8ba,     88   8b       d8 88       d8
// aa    ]8I   88,  "8a,   ,a8" 88b,   ,a8"
// `"YbbdP"'   "Y888 `"YbbdP"'  88`YbbdP"'
//                             88
//                             88

// this file is deprecated in favor of individual type files
// located in `Shared/types/...`
// see the `Attachemnt` right below, this is good type definition

import { Attachment } from 'Shared/types/Attachment.type';
import { BillingPlan } from 'Shared/types/Organization.type';

export enum ItemType {
  discussionTopic = 'discussion_topic',
  actionItem = 'action_item',
}

export enum ItemPosition {
  positionForHomePage = 'positionForHomePage',
  positionForGoalDetailPage = 'positionForGoalDetailPage',
  positionForWorkspacePage = 'position',
  positionForTeamPage = 'positionForTeamPage',
  positionForActionItemsPage = 'positionForActionItemsPage',
}

export enum UserRole {
  admin = 'admin',
  fullMember = 'full_member',
  manager = 'manager',
}

export enum WorkspaceType {
  isPersonal = 'is_personal',
  isTeammate = 'is_teammate',
  isGroup = 'is_group',
}

export enum OrganizationRole {
  admin = 'admin',
  regularUser = 'regular_user',
}

export enum RecurringMeetingSource {
  google = 'google',
  office365 = 'office_365',
  member = 'member',
  groupMeeting = 'group_meeting',
}

export enum NotificationCardType {
  generatedFromMeeting = 'generated_from_meeting',
  newMeetingAttendeesFound = 'new_meeting_attendees_found',
  connectCalendar = 'connect_calendar',
  leftKudos = 'someone_left_kudos',
  viewedKudos = 'someone_viewed_kudos',
  giveKudos = 'give_kudos',
  timeForFeedback = 'time_for_feedback',
  leftFeedbackYouDidnt = 'someone_left_feedback_you_didnt',
  leftFeedback = 'someone_left_feedback',
  commentFeedback = 'someone_commented_on_feedback',
  customizeManagerAssist = 'customize_manager_assist',
  createSuggestedTopics = 'create_suggested_topics',
  featurePromotion = 'feature_promotion',
  feedbackRequested = 'feedback_requested',
  bidirectionalFeedback = 'bidirectional_feedback',
}

export enum WebNotificationType {
  giveFeedbackReminder = 'give_feedback_reminder',
  giveKudosReminder = 'give_kudos_reminder',
  kudos = 'kudos',
  feedback = 'feedback',
  publicKudos = 'public_kudos',
  draftFeedback = 'draft_feedback',
  feedbackRequested = 'feedback_requested',
  feedbackRequestedReminder = 'feedback_requested_reminder',
  meetingTranscriptionReady = 'meeting_transcription_ready',
}

export enum WorkspaceTemplateType {
  oneOnOne = 'one_on_one',
  team = 'team',
}

export enum DynamicTemplateType {
  newHireKickoff = 'new_hire_kickoff',
}

export enum NotificationCardButton {
  close = 'close',
  snooze = 'snooze',
}

/**
 * @deprecated Import from 'Shared/types/Goal.type' instead.
 * This export is kept for backwards compatibility but will be removed in a future version.
 */
export type { GoalStatusType } from 'Shared/types/Goal.type';

/**
 * @deprecated Import from 'Shared/types/Goal.type' and use goalStatusTranslationKeys with tr() function instead.
 * This export is kept for backwards compatibility but will be removed in a future version.
 */
export { GoalStatusesLabel } from 'Shared/types/Goal.type';

/**
 * @deprecated Import from 'Shared/types/Goal.type' instead.
 * This export is kept for backwards compatibility but will be removed in a future version.
 */
export { GoalIcons } from 'Shared/types/Goal.type';

/**
 * @deprecated Import from 'Shared/types/Goal.type' instead.
 * This export is kept for backwards compatibility but will be removed in a future version.
 */
export { GoalMetricTypeType } from 'Shared/types/Goal.type';

/**
 * @deprecated Import from 'Shared/types/Goal.type' instead.
 * This export is kept for backwards compatibility but will be removed in a future version.
 */
export type { GoalItem } from 'Shared/types/Goal.type';

export type WorkspaceItem = {
  id: number;
  uuid: string;
  body: string;
  isSection: boolean;
  isHighPriority: boolean;
  position: number;
  completed: boolean;
  assignmentId: number;
  assignmentPersonId: number;
  itemType: string;
  recurringWorkspaceItem: RecurringWorkspaceItem;
  positionForActionItemsPage: number;
  attachments?: Array<Attachment>;
  assignee: {
    userId: number;
    personName: string;
  };
  comments: Array<{}>;
  video: VideoType;
  parentUuid: string;
  parentText: string;
  isShowLoader: boolean;
  parentId: number;
  showPreview: boolean;
  user: WorkspaceMember;
  workspaceId: string;
  workspacePath: string;
  workspaceName: string;
  dueBy: number;
  goalSlug: string;
  createdAt: Date;
  asanaData?: {
    url: string;
    taskId: string;
  };
  jiraData?: {
    url: string;
  };
  servicenowData?: {
    url: string;
  };
};

export type WorkspaceTemplate = {
  slug: string;
  name: string;
  recommended: boolean;
  piRecommended: boolean;
  description: string;
  isCustom: boolean;
  isPublic: boolean;
  piOnly: boolean;
  dynamicTemplateType: DynamicTemplateType;
  templateType: WorkspaceTemplateType;
  sections: Array<WorkspaceTemplateSection>;
};

export type WorkspaceTemplateSection = {
  name: string;
  description: string;
  discussionTopics: Array<string>;
};

// TODO: deprectate this type in favor of `Shared/types/Attachment.type`
export type AttachmentType = {
  id?: number;
  url: string;
  fileName: string;
  contentType: string;
  isImage: boolean;
};

export type RecurringWorkspaceItem = {
  id: string;
  dayOfWeek: string;
  timeOfDay: string;
  intervalAmount: string;
  intervalUnit: string;
  startsAt: string;
  dayInMonth: number;
  weekInMonth: number;
};

export type VideoType = {
  id: number;
  audioOnly: boolean;
  mp4Url: string;
  previewImageUrl: string;
  transcription: string;
  type: string;
  url: string;
  sources: Array<string>;
};

export type SelectorValue = {
  label: string;
  value: string;
};

export type Workspace = {
  id: string;
  name: string;
  displayLabel: string;
  isGroup: boolean;
  users: Array<WorkspaceMember>;
};

export type WorkspaceMember = {
  id: number;
  email: string;
  firstName: string;
  fullName: string;
  full_name: string;
  avatar: AvatarType;
};

export type AvatarType = {
  profilePictureUrl?: string;
  color: string;
  initials: string;
  borderColor?: string;
  outerWrapperColor?: string;
};

export type WorkspaceNotificationCard = {
  id: number;
  type: string;
  userId: number;
  workspaceId: number;
  link: string;
  snoozed: boolean;
  active: boolean;
  read: boolean;
  subtype: string;
  feedbackInfo: {
    creator: {
      id: number;
      firstName: string;
    };
    receiver: {
      id: number;
      firstName: string;
    };
  };
  otherUser: { firstName: string };
  recognitionRequestId: number;
  tryOutRecognition: boolean;
};

export type FeedbackCommentType = {
  uuid: string;
  body: string;
  createdAt: Date;
  discardedAt: Date;
  feedbackUuid: string;
  isEdited: boolean;
  workspaceUuid: string;
  feedbackRecognitionRequestId: number;
  user: WorkspaceMember;
  video: VideoType;
  viewerIds: Array<number>;
};

export type FeedbackRecognitionType = {
  uuid: string;
  workspaceUuid: string;
  workspaceName: string;
  requestType: string;
  creatorId: number;
  receiverId: number;
  likeThatText: string;
  escapedLikeThatText: string;
  feedbacksCountInFeedbackRequest: number;
  feedbackRecognitionRequestId: number;
  gifUrl: string;
  likeThatVideo: VideoType;
  wishThatText: string;
  wishThatVideo: VideoType;
  createdAt: string;
  comments: Array<FeedbackCommentType>;
  recipientViewed: boolean;
  viewerIds: Array<number>;
  templateType?: string;
  isDraft: boolean;
  isPublic: boolean;
  answers: object;
  reviewTemplateSlug?: string;
};

type RecurringMeetingAttendees = Array<{
  email: string;
  fullName: string;
  displayName: string;
}>;

export type RecurringMeeting = {
  id: number;
  name: string;
  source: RecurringMeetingSource;
  attendees: RecurringMeetingAttendees;
  isGroup?: boolean;
};

export type ParamsForCreateWorkspace = {
  uuid: string;
  selected: boolean;
  recurringMeetingId?: number;
  recurringMeetingName?: string;
  name: string;
  displayName: string;
  source: RecurringMeetingSource;
  inviteAttendees: boolean;
  attendees?: RecurringMeetingAttendees;
  teammateEmail?: string;
  teammateAvatar?: AvatarType;
  teammateName?: string;
  personalMessage: string;
  isCustom: boolean;
};

export enum BootstrapColor {
  primary = 'primary',
  secondary = 'secondary',
  success = 'success',
  danger = 'danger',
  warning = 'warning',
  info = 'info',
  light = 'light',
  dark = 'dark',
  muted = 'muted',
  white = 'white',
}

export enum GuideStepStatus {
  pending = 'pending',
  completed = 'completed',
}

export enum DataSourceSlugs {
  slack = 'slack-individual-authorization',
  zoom = 'zoom',
  zoomInClientApp = 'zoom_in_client_app',
  googleDrive = 'g-suite-drive-individual-authorization',
  googleCalendar = 'g-suite-calendar-individual-full-authorization',
  googleCalendarWorkspaceSync = 'g-suite-calendar-workspace-sync-individual-authorization',
  office365Calendar = 'office-365-calendar-workspace-sync-individual-authorization',
  office365Onedrive = 'office-365-onedrive-individual-authorization',
  github = 'github',
  asana = 'asana',
  jira = 'jira',
  figma = 'figma',
  onedrive = 'office-365-onedrive-individual-authorization',
  salesforce = 'salesforce',
  hubspot = 'hubspot',
  servicenow = 'servicenow',
  slackAi = 'slack-ai',
}

export enum FormIfOperator {
  include = 'include',
  equal = 'equal',
  notInclude = 'notInclude',
  notEqual = 'notEqual',
  notEmpty = 'notEmpty',
}

export enum NotificationDestinationSlugs {
  slack = 'slack',
  microsoftTeams = 'microsoft_teams',
}

export enum FeedbackRecognitionTemplateTypes {
  feedbackBlankTemplate = 'feedback_blank_template',
  feedbackLikeThatWishThatTemplate = 'feedback_like_that_wish_that_template',
  feedbackStrengthsOpportunitiesTemplate = 'feedback_strengths_opportunities_template',
  feedbackfromReviewTemplateTemplate = 'from_review_template',
  feedbackGPT3Coach = 'feedback_gpt3_coach',
  kudosDefault = 'kudos_default',
  threeSixtyReview = 'three_sixty_review',
  selfThreeSixtyReview = 'self_three_sixty_review',
}

export enum FeedbackRecognitionRequestTypes {
  feedback = 'FeedbackRequest',
  recognition = 'RecognitionRequest',
}

export enum FeedbackTypes {
  feedback = 'feedback',
  kudos = 'kudos',
}

export enum MemberActivityStatus {
  active = 'active',
  inactive = 'inactive',
  pending = 'pending',
}

export type Subscription = {
  plan_name: string;
  brand: string;
  last4: string;
  price_per_month?: number;
  next_billing_date: number;
  upcoming_invoice: {
    amount: number;
    subscription_amount: number;
  };
  proration_amount: number;
  billing_cycle: string;
  proration: {
    amount: number;
    due_on: number;
  };
  features: {
    goals: {
      state: BillingPlan;
    };
    reviews: {
      state: BillingPlan;
    };
  };
};

// TODO (josh) : some of these should be enums, just not sure all the options
export type User = {
  id: number;
  primary: boolean;
  email: string;
  fullName: string;
  firstName: string;
  lastName: string;
  avatar: AvatarType;
  confirmationSentAt: string;
  confirmedAt: string;
  pulseMood: string;
  displayName: string;
  personId: number;
  personIdentifier: string;
  slug: string;
  label: string;
  zoomData: Record<string, any>;
  hasSlackNotifications: boolean;
  role: UserRole;
  organizationRole: string;
  title: string;
  department: string;
  // type not defined due to small bug with
  // the select and strings vs numbers
  managerId;
  pi_user_guid?: string;
  piUserGuid?: string;
  lastSeenAt?: string;
  isPredictiveIndexEmployee: boolean;
};

export type SelectedSort = {
  actionItems: string;
  owner?: string;
  workspace?: string;
  dueDate: string;
};

export type DataSource = {
  id: number;
  slug: string;
  name: string;
  connected: boolean;
  path: string;
  logo: string;
  isCalendar: boolean;
  description: string;
};
